import { OPPORTUNITY_METRICS_CATEGORY } from '@src/utils/kpi';

export function KPIOrder(chartData) {
  const METRIC_ARR: any[] = [];
  const STARTUP_SORTED: any[] = [];
  const PLAYBACK_SORTED: any[] = [];
  const { STARTUP_FAIL } = OPPORTUNITY_METRICS_CATEGORY;
  Object.keys(chartData).forEach((key) => {
    METRIC_ARR.push({
      name: key,
      value: chartData[key]._aggregate,
    });
  });
  METRIC_ARR.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));
  let emptyCounter = 0;
  METRIC_ARR.forEach((metric) => {
    if (STARTUP_FAIL.includes(metric.name)) {
      STARTUP_SORTED.push(metric.name);
    } else {
      PLAYBACK_SORTED.push(metric.name);
    }
    if (metric.value === null) {
      emptyCounter += 1;
    }
  });
  return {
    METRIC_ARR,
    STARTUP_SORTED,
    PLAYBACK_SORTED,
    emptyMetrics: emptyCounter,
    totalMetrics: METRIC_ARR.length,
  };
}
